import { z } from "zod";

// Define accepted PDF types
const ACCEPTED_PDF_TYPES = ["application/pdf", "pdf"];

// Define file schema
const fileSchema = z.object({
  fileName: z.string().optional(), // The fileName should be optional in case no file is provided
  name: z.string().optional(), // Same for other fields, making them optional
  fileSize: z.number().optional(),
  size: z.number().optional(),
  key: z.string().optional(), // key is optional as well
});

// Maximum image upload limit
export const IMG_MAX_LIMIT = 1;

// Press schema for creating a new entry
export const actSchema = z.object({
  title: z
    .string({ required_error: "Le titre est obligatoire" })
    .min(3, { message: "Le titre doit contenir au moins 3 caractères." }),
  file: z
    .object(fileSchema.shape, { required_error: "Le fichier PDF est obligatoire" })
    .refine(
      (file) => {
        const fileExtension = file.fileName?.split(".").pop()?.toLowerCase();
        return fileExtension && ACCEPTED_PDF_TYPES.includes(fileExtension);
      },
      { message: "Seul un fichier au format PDF est accepté." }
    ),
  category: z
    .string({ required_error: "La catégorie est obligatoire" })
    .min(1, { message: "Veuillez sélectionner une catégorie." }),
  
    subCategory: z.string().optional(),
  date: z.date({ required_error: "La date est obligatoire" }),
})
.superRefine((data, ctx) => {
  const { category, subCategory } = data;
  if (["comité", "bureau"].includes(category?.toLowerCase()) && !subCategory) {
    ctx.addIssue({
      path: ["subCategory"],
      code: z.ZodIssueCode.custom,
      message: "La sous-catégorie est obligatoire pour cette catégorie.",
    });
  }
});

// Type for creating a new press entry
export type ActFormValues = z.infer<typeof actSchema>;

// Press schema for updating an existing entry
export const updatedActSchema = z
  .object({
    title: z
      .string()
      .min(3, { message: "Le titre doit contenir au moins 3 caractères." })
      .optional(),

    category: z
      .string()
      .min(1, { message: "Le titre doit contenir au moins 3 caractères." })
      .optional(),

    subCategory: z
      .string()
      .min(1, { message: "Le titre doit contenir au moins 3 caractères." })
      .optional(),

    date: z.date().optional(),

    file: fileSchema
      .refine(
        (file) => {
          const fileExtension = file.fileName?.split(".").pop()?.toLowerCase();
          return fileExtension && ACCEPTED_PDF_TYPES.includes(fileExtension);
        },
        { message: "Seul un fichier au format PDF est accepté." }
      )
      .optional(),
  })
  .partial();

// Type for updating an existing press entry
export type UpdatedActFormValues = z.infer<typeof updatedActSchema>;
